import { render } from "./WhyWeAre.vue?vue&type=template&id=5f912aa2"
import script from "./WhyWeAre.vue?vue&type=script&lang=js"
export * from "./WhyWeAre.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__